import { COMMON_WAIFUS, getCommonReviews } from '../../../constants.js';

export const JA_BASE = {
    hero: {
      title: "Waifu Briscola",
      tagline: "見たことのないブリスコラ：RPG、Waifu、そしてAI。",
      ctaWeb: "Webでプレイ",
      ctaAndroid: "Androidでダウンロード",
      version: "バージョン 2.3",
      badge: "✨ 新ダンジョンモード"
    },
    stats: {
      downloads: "ダウンロード数",
      downloadsValue: ["数え切れない！", "サーバー満員", "たくさん！", "9000以上", "数え切れないほど"],
      hands: "負けた手",
      handsValue: ["多すぎる...", "実力不足", "ラグのせい", "まだ泣いてる", "リトライして、次は運がいいかも"],
      rating: "評価",
      ratingValue: ["おばあちゃん公認", "11/10 - IGN", "ピザより良い", "GOTY 2026", "絶対的な傑作"],
      waifus: "Waifu",
      waifusValue: ["全部君のもの", "2D > 3D", "全部集めよう！", "Waifu > メタ", "真の宝物"]
    },
    features: {
      title: "ただのカードゲーム以上のもの",
      items: [
        { id: "classic", title: "クラシックブリスコラ", description: "オリジナルの体験、完璧でクリーン。", icon: "🃏" },
        { id: "roguelike", title: "RPGローグライク", description: "塔を登り、属性の力を得てボスを倒せ。", icon: "⚔️" },
        { id: "ai", title: "生きているAI", description: "Google Geminiのおかげで、対戦相手はリアルタイムであなたを罵倒したり称賛したりします。", icon: "🧠" },
        { id: "gacha", title: "ガチャシステム", description: "コインを使って新しいスキンやレアな背景をアンロック。", icon: "💎" },
        { id: "dungeon", title: "ダンジョンモード", description: "狂ったルールのボスに挑め。一度負ければ終わり。", icon: "🏰" },
        { id: "puzzle", title: "パズルモード", description: "特定の目標を持つ複雑なシナリオを解決。", icon: "🧩" }
      ]
    },
    video: { title: "ゲームプレイトレーラー" },
    waifus: {
      title: "パートナーを選ぼう",
      subtitle: "各キャラクターには独自の性格、吹き替え、プレイスタイルがあります。",
      characters: [
        { ...COMMON_WAIFUS[0], name: "Miu", role: "癒し系", personality: "甘くて明るい、あなたのそばにいるのが好き。" },
        { ...COMMON_WAIFUS[1], name: "Rei", role: "分析家", personality: "計算高く冷淡。論理のみ。" },
        { ...COMMON_WAIFUS[2], name: "Akame", role: "ツンデレ", personality: "負けず嫌いで情熱的。敗北を嫌う。" },
        { ...COMMON_WAIFUS[3], name: "Lilith", role: "女王", personality: "カードの闇の女王。" },
        { ...COMMON_WAIFUS[4], name: "Mochi", role: "ガイド", personality: "信頼できるガイド...たぶん。" }
      ]
    },
    reviews: {
      title: "みんなの声（残念ながら）",
      items: getCommonReviews('ja')
    },
    ctaStrip: {
      title: "フィールドに出る準備はできた？",
      subtitle: "他のプレイヤーに参加して、今すぐ冒険を始めよう。",
      button: "今すぐプレイを開始"
    },
    footer: { privacy: "プライバシー", terms: "利用規約", copyright: "© 2026 Waifu Briscola" },
    privacy: {
      title: "Waifu Briscola プライバシーポリシー",
      lastUpdated: "最終更新日：2024年5月25日",
      intro: "このプライバシーポリシーは、Waifu Briscolaアプリケーション（「サービス」）を使用する際の情報の取り扱いについて説明します。",
      sections: [
        {
          title: "収集する情報",
          intro: "体験を向上させるために、情報を収集する可能性のあるサードパーティサービスを使用しています：",
          items: [
            "利用データ (PostHog): ゲームとのやり取りに関する匿名または仮名の分析データを収集します。これには、ゲーム開始、プレイされたカード、最終結果などのイベントが含まれます。これらのデータは、ゲームがどのように使用されているかを理解し、改善するのに役立ちます。PostHogを通じて個人識別情報（PII）を収集することはありません。",
            "AIとの対話 (Google Gemini): 送信するチャットメッセージやゲームの状態に関する情報（手札やテーブル上のカードなど）は、AIの応答や動きを生成するためにGoogle Gemini APIに送信されます。これらの対話はGoogleのプライバシーポリシーの対象となります。ゲームの対話内容以外の個人情報をGoogleに送信することはありません。",
          ],
        },
        {
          title: "情報の利用方法",
          intro: "収集した情報は以下の目的で使用します：",
          items: [
            "サービスの提供、運営、維持。",
            "サービスの改善、パーソナライズ、拡大。",
            "サービスの利用状況の理解と分析。",
            "不正使用の防止とセキュリティの確保。",
          ],
        },
        {
          title: "情報の共有",
          body: "上記で説明したように、アプリケーションの動作に必要なサードパーティサービスプロバイダー（PostHog、Google）を除き、個人情報を誰とも共有しません。",
        },
        {
          title: "データのセキュリティ",
          body: "情報のセキュリティは重要ですが、インターネット上の送信方法や電子保存方法は100％安全ではないことを忘れないでください。",
        },
        {
          title: "このプライバシーポリシーの変更",
          body: "プライバシーポリシーを随時更新することがあります。変更がある場合は、このページに新しいプライバシーポリシーを掲載してお知らせします。",
        },
        {
          title: "お問い合わせ",
          body: "このプライバシーポリシーについてご質問がある場合は、責任者Mauro Mazzocchettiまでお問い合わせください。",
        },
      ],
    },
    consent: { text: "サイト改善のためにCookieと分析データを使用しています。続行すると以下に同意したものとみなされます:", ok: "了解" },
    terms: {
      title: "Waifu Briscola 利用規約",
      lastUpdated: "最終更新日：2024年5月25日",
      contact: "責任者：Mauro Mazzocchetti",
      intro: "Waifu Briscolaへようこそ！これらの利用規約は、Waifu Briscolaアプリケーション（「サービス」）の使用に関するルールを概説しています。",
      sections: [
        {
          title: "規約の同意",
          body: "このサービスにアクセスして使用することにより、これらの規約に拘束されることに同意したことになります。規約のいずれかの部分に同意しない場合は、サービスを使用できません。",
        },
        {
          title: "サービスの利用",
          body: "違法または不正な目的でサービスを使用しないことに同意します。あなたは自分の行動と、チャットメッセージを含め、サービスの使用中に提供するすべてのコンテンツに対して責任を負います。",
        },
        {
          title: "AI生成コンテンツ",
          intro: "サービスは、応答、コメント、ゲームの動きを生成するために人工知能モデル（Google Gemini）を使用します。以下を認識するものとします：",
          items: [
            "AI生成コンテンツはモデルによって生成され、常に正確、適切、または一貫しているとは限りません。",
            "私たちはAI生成コンテンツに対して責任を負いません。",
            "AIとの対話は娯楽のみを目的としています。",
          ],
        },
        {
          title: "責任の制限",
          body: "いかなる場合も、Mauro Mazzocchettiまたはそのパートナーは、(i) サービスへのアクセスもしくは使用、またはアクセスもしくは使用不能、(ii) サービスから取得したコンテンツに起因する、利益の損失、データ、信用の損失、またはその他の無形の損失を含むがこれらに限定されない、間接的、偶発的、特別、結果的、または懲罰的損害に対して責任を負わないものとします。",
        },
        {
          title: "規約の変更",
          body: "私たちは独自の裁量により、いつでもこれらの規約を変更または置き換える権利を留保します。変更がある場合は、このページに新しい規約を掲載してお知らせします。",
        },
        {
          title: "準拠法",
          body: "これらの規約は、法の抵触に関する規定にかかわらず、イタリアの法律に準拠し、解釈されるものとします。",
        },
      ],
    }
};
